var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 18",
    width: 22,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#a32fa3}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m19.5 0h-17.3q-0.5 0-0.9 0.2-0.4 0.1-0.7 0.4-0.3 0.3-0.4 0.7-0.2 0.4-0.2 0.9v13q0 0.4 0.2 0.8 0.1 0.4 0.4 0.7 0.3 0.3 0.7 0.5 0.4 0.1 0.9 0.1h17.3q0.4 0 0.8-0.1 0.4-0.2 0.7-0.5 0.3-0.3 0.5-0.7 0.2-0.4 0.2-0.8v-13q0-0.5-0.2-0.9-0.2-0.4-0.5-0.7-0.3-0.3-0.7-0.4-0.4-0.2-0.8-0.2zm0 15.2h-17.3v-10.9l8.6 5.4 8.7-5.4zm-8.7-7.5l-8.6-5.5h17.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.02a499cb0dcfa08be1553ad1e7baf20b.svg";
export { ForwardRef as ReactComponent };